export default {
  en: {
    subtotal: 'Subtotal',
    dailyActivityReport: 'Daily Activity Report',
    productMix: 'Product Mix',
    productMixAnalysis: 'Product Mix Analysis',
    shiftManagerSummary: 'Shift Manager Summary',
    shiftManagerSummaryAnalysis: 'Shift Manager Summary Analysis',
    footerDisclaimer: '* Metrics are averaged by the number of shifts worked',
    gridName: 'Grid Name',
    byDate: 'By Date',
    byMonth: 'By Month',
    sumAllDates: 'Sum all Dates',
    customDateRange: 'Custom Date Range',
    targets: 'Targets',
    total: 'Total',
    'last-year': 'Last Year',
    'previous-year': 'Previous Year',
    yes: 'Yes',
    no: 'No',
    sunday: 'Sunday',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    // QuickTimes
    day: 'Day',
    timeslices: 'Timeslices',
    custom: 'Custom',
    'time-segment': 'Time Segment',
    // DateAgg
    'by-date': 'By Date',
    'by-month': 'By Month',
    // SameStoreComp
    'all-store-comp': 'All Store',
    'same-store-comp': 'Same Store',
    'comp-tooltip-header': 'Choose the type of comp you want displayed:',
    'comp-tooltip-same-store-title': 'Same Store Comp:',
    'comp-tooltip-same-store-body':
      'compare stores that were open this year to stores also open last year.',
    'comp-tooltip-all-store-title': 'All Store Comp:',
    'comp-tooltip-all-store-body':
      'all data for all stores this year versus all data for all stores last year.',
    // CompType
    'comp-type-trading': 'Trading',
    'comp-type-calendar': 'Calendar',
  },
  es: {
    subtotal: 'Subtotal',
    dailyActivityReport: 'Reporte de Actividad Diaria',
    productMix: 'Mezcla de Productos',
    productMixAnalysis: 'Análisis de Mezcla de Productos',
    shiftManagerSummary: 'Resumen del Jefe de Turno',
    shiftManagerSummaryAnalysis: 'Análisis del Resumen del Jefe de Turno',
    footerDisclaimer:
      '* Las métricas se promedian por el número de turnos trabajados',
    gridName: 'Nombre de la Cuadrícula',
    byDate: 'Por Fecha',
    byMonth: 'Por Mes',
    sumAllDates: 'Sumar todas las Fechas',
    customDateRange: 'Rango de Fechas Personalizado',
    targets: 'Objetivos',
    total: 'Total',
    'last-year': 'Año Anterior',
    'previous-year': 'Año Previo',
    yes: 'Sí',
    no: 'No',
    sunday: 'Domingo',
    monday: 'Lunes',
    tuesday: 'Martes',
    wednesday: 'Miércoles',
    thursday: 'Jueves',
    friday: 'Viernes',
    saturday: 'Sábado',
    // QuickTimes
    day: 'Día',
    timeslices: 'Segmentos de tiempo',
    custom: 'Personalizado',
    'time-segment': 'Segmento de tiempo',
    // DateAgg
    'by-date': 'Por Fecha',
    'by-month': 'Por Mes',
    // SameStoreComp
    'all-store-comp': 'Todas las Tiendas',
    'same-store-comp': 'Misma Tienda',
    'comp-tooltip-header': 'Elige el tipo de comparación que deseas mostrar:',
    'comp-tooltip-same-store-title': 'Comparación de la Misma Tienda:',
    'comp-tooltip-same-store-body':
      'compara las tiendas abiertas este año con las tiendas también abiertas el año pasado.',
    'comp-tooltip-all-store-title': 'Comparación de Todas las Tiendas:',
    'comp-tooltip-all-store-body':
      'todos los datos de todas las tiendas este año versus todos los datos de todas las tiendas el año pasado.',
    // CompType
    'comp-type-trading': 'Comercio',
    'comp-type-calendar': 'Calendario',
  },
};
